<template>
  <div class="form-outline mb-5 mt-5 d-flex justify-content-between" style="display: flex!important;justify-content: space-between!important; margin: 20px auto;">
    <label for="coupon" class="text-nowrap mb-2">have a coupon ? </label>
    <input type="text" placeholder="Coupon code" class="form-control" @keyup="checkCouponIsValid" v-model="couponCode">
  </div>
  <div class="mb-4 mt-4 d-flex justify-content-between" v-if="couponMessage"><small style="color: var(--primary)">{{ couponMessage }}</small></div>
</template>

<script>
export default {
  name: "couponInputComponent",
  data() {
    return {
      couponCode: null,
      couponMessage: null,
    }
  },
  emits: ['onSetCouponCode'],
  methods: {
    checkCouponIsValid(){

      fetch(`${process.env.VUE_APP_BASEURI}/courses/coupon/by-course?course_id=${this.courseId}&coupon_code=${this.couponCode}`, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      })
          .then(response => {
            if (response.ok) {
              response.json().then(res => {
                this.couponMessage = this.couponCode.length > 0 ? res.message : null
                if(res.result){ // send emit only of true (coupon applied) VRPXTQSG
                  res.code = this.couponCode
                  this.$emit('onSetCouponCode', res)
                }else {
                  this.$emit('onSetCouponCode', null)
                }
                // else
                // {
                //   console.log('err')
                // }
              })
            }
            else {
              response.json().then(err => {
                if (!err.success) console.log(err)
              })
            }
          })
    },
    setCouponCode(){
      this.$emit('onSetCouponCode', {
        coupon_code: this.couponCode,
        course_id: this.courseId,
      })
    },
  },
  props: {
    courseId: Number,
  },
}
</script>

<style scoped>

</style>